import css from './videoAd.module.scss';

export function VideoAdSlot() {
  return <div id="web-media-player-ad-container" className={css.videoAdSlot} />;
}
